import man1 from "../../../Assets/icons/Persons/man1.png";
import man2 from "../../../Assets/icons/Persons/man2.png";
import man3 from "../../../Assets/icons/Persons/man3.png";
import man4 from "../../../Assets/icons/Persons/man4.png";
import woman5 from "../../../Assets/icons/Persons/woman5.png";

export const TestimonialsData = [
    {
        id: 0,
        name: "Raj Bansh",
        desc: "Worknzi's app for our battery company distributors is a game-changer. Simple, efficient, and exactly what we needed.",
        designation: "Manager",
        img: man1,
    },
    {
        id: 1,
        name: "Supradip",
        desc: "Thanks to Worknzi, managing our Medbriki app is now a breeze. Their admin dashboard is intuitive and user-friendly.",
        designation: "Web Developer",
        img: man2,
    },
    {
        id: 2,
        name: "Shubham Aditya",
        desc: "Worknzi handled our massive code copy-paste task swiftly and accurately. Reliable and professional service.",
        designation: "Sr Data scientist @ HackerEarth",
        img: man3,
    },
    {
        id: 3,
        name: "Anand Prasad",
        desc: "My portfolio website by Worknzi showcases my work beautifully. They captured my essence perfectly.",
        designation: "Associate Designer @ Crezvatic",
        img: man4,
    },
    {
        id: 4,
        name: "Disha",
        desc: "Worknzi's C++ project on ambulance time optimization is impressive. Innovative solutions that make a difference.",
        designation: "SDE @ Sap Labs",
        img: woman5,
    },
]